/* Amiraya: theme-only discount input. Shopify calculates any eligible discount. */
(() => {
  'use strict';

  let inFlight = false;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const getCartUrl = () => window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
  const getUpdateUrl = () => window.routes?.cart_update_url || `${window.Shopify?.routes?.root || '/'}cart/update`;

  function sectionRequests() {
    const ids = ['cart-drawer'];
    for (const id of ['main-cart-footer', 'main-cart-items']) {
      const element = document.getElementById(id);
      if (element?.dataset?.id) ids.push(element.dataset.id);
    }
    return [...new Set(ids)];
  }

  function refreshSection(responseHtml, parentSelector, childSelector) {
    if (!responseHtml) return;
    const source = parse(responseHtml).querySelector(parentSelector);
    const target = document.querySelector(parentSelector);
    if (!source || !target) return;
    const from = childSelector ? source.querySelector(childSelector) : source;
    const into = childSelector ? target.querySelector(childSelector) : target;
    if (from && into) into.innerHTML = from.innerHTML;
  }

  function renderCartChanges(sections) {
    if (!sections || typeof sections !== 'object') return;
    const footerId = document.getElementById('main-cart-footer')?.dataset?.id;
    const itemsId = document.getElementById('main-cart-items')?.dataset?.id;

    if (footerId && sections[footerId]) {
      refreshSection(sections[footerId], '#main-cart-footer', '.js-contents');
    }
    if (itemsId && sections[itemsId]) {
      refreshSection(sections[itemsId], '#main-cart-items', '.js-contents');
    }
    if (sections['cart-drawer']) {
      refreshSection(sections['cart-drawer'], '#CartDrawer-CartItems');
      refreshSection(sections['cart-drawer'], '.cart-drawer__footer');
    }
  }

  function setMessage(message, state, text) {
    message.textContent = text || message.dataset[state] || '';
    message.dataset.state = state;
  }

  function getFields() {
    return [...document.querySelectorAll('[data-am-discount-field]')];
  }

  function setBusy(isBusy) {
    for (const field of getFields()) {
      field.querySelectorAll('[data-am-discount-apply], [data-am-discount-remove]').forEach((button) => {
        button.disabled = isBusy;
      });
      field.setAttribute('aria-busy', String(isBusy));
    }
  }

  async function updateDiscount(code) {
    const response = await fetch(getUpdateUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        discount: code,
        sections: sectionRequests(),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) {
      throw new Error(data.description || data.message || 'Shopify cart update failed');
    }
    renderCartChanges(data.sections);
    return data;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-am-discount-form]');
    if (!form) return;
    event.preventDefault();
    if (inFlight) return;
    const field = form.closest('[data-am-discount-field]');
    const input = form.querySelector('input[name="discount_code"]');
    const message = field.querySelector('[data-am-discount-message]');
    const code = input.value.trim();
    if (!code) {
      setMessage(message, 'empty');
      input.focus();
      return;
    }

    inFlight = true;
    setBusy(true);
    setMessage(message, 'pending');
    try {
      const before = await fetch(getCartUrl() + '.js', { credentials: 'same-origin' }).then((r) => r.json());
      const after = await updateDiscount(code);
      const reflected = typeof after.total_price === 'number' &&
        typeof before.total_price === 'number' && after.total_price < before.total_price;
      for (const block of getFields()) {
        const status = block.querySelector('[data-am-discount-message]');
        setMessage(status, reflected ? 'reflected' : 'done');
        block.querySelector('[data-am-discount-remove]').hidden = false;
      }
    } catch (error) {
      console.error('[Amiraya discount]', error);
      setMessage(message, 'error');
    } finally {
      inFlight = false;
      setBusy(false);
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-am-discount-remove]');
    if (!button || inFlight) return;
    event.preventDefault();
    inFlight = true;
    setBusy(true);
    const field = button.closest('[data-am-discount-field]');
    setMessage(field.querySelector('[data-am-discount-message]'), 'pending');
    try {
      await updateDiscount('');
      for (const block of getFields()) {
        block.querySelector('input[name="discount_code"]').value = '';
        block.querySelector('[data-am-discount-remove]').hidden = true;
        setMessage(block.querySelector('[data-am-discount-message]'), 'removed');
      }
    } catch (error) {
      console.error('[Amiraya discount]', error);
      setMessage(field.querySelector('[data-am-discount-message]'), 'error');
    } finally {
      inFlight = false;
      setBusy(false);
    }
  });
})();
